import dynamic from 'next/dynamic';
import { RedemptionsAlertProps } from './RedemptionNotification.types';

export const RedemptionNotificationMGP = dynamic<RedemptionsAlertProps>(() => import('./RedemptionNotification'));
